import styled from "styled-components";

import { Text } from "@components/Text";

const StyledText = styled(Text)`
  font-size: inherit !important;
`;
export default StyledText;
